export const contactSchema = {
  customer: {
    value: '',
    type: 'option',
    required: true,
    options: [],
    searchable: true,
  },
  registrar: {
    value: 'oxxa',
    type: 'option',
    required: true,
    options: ['oxxa', 'xolphin', 'none'],
  },
  companyName: {
    value: '',
    type: 'string',
    required: false,
  },
  jobTitle: {
    value: '',
    type: 'string',
    required: true,
  },
  firstName: {
    value: '',
    type: 'string',
    required: true,
  },
  lastName: {
    value: '',
    type: 'string',
    required: true,
  },
  street: {
    value: '',
    type: 'string',
    required: true,
  },
  houseNumber: {
    value: '',
    type: 'string',
    required: true,
  },
  houseNumberSuffix: {
    value: '',
    type: 'string',
    required: false,
  },
  postalCode: {
    value: '',
    type: 'string',
    required: true,
  },
  city: {
    value: '',
    type: 'string',
    required: true,
  },
  state: {
    value: '',
    type: 'string',
    required: true,
  },
  tel: {
    value: null,
    type: 'string',
    required: true,
  },
  fax: {
    value: '',
    type: 'string',
    required: false,
  },
  email: {
    value: '',
    type: 'string',
    required: true,
  },
  country: {
    value: '',
    type: 'option',
    searchable: true,
    required: true,
    options: [],
  },
  dateBirth: {
    value: '',
    type: 'date',
    required: false,
  },
  placeBirth: {
    value: '',
    type: 'string',
    required: false,
  },
  countryBirth: {
    value: '',
    type: 'option',
    searchable: true,
    options: [],
    required: false,
  },
  postalBirth: {
    value: '',
    type: 'string',
    required: false,
  },
  idNumber: {
    value: '',
    type: 'string',
    required: false,
  },
  regNumber: {
    value: '',
    type: 'string',
    required: false,
  },
  vatNumber: {
    value: '',
    type: 'string',
    required: false,
  },
  tmNumber: {
    value: '',
    type: 'string',
    required: false,
  },
  tmCountry: {
    value: '',
    type: 'option',
    searchable: true,
    required: false,
    options: [],
  },
  tmName: {
    value: '',
    type: 'string',
    required: false,
  },
  hkIndustryType: {
    value: '',
    type: 'string',
    required: false,
  },
  idCardDate: {
    value: '',
    type: 'date',
    required: false,
  },
  idCardIssuer: {
    value: '',
    type: 'string',
    required: false,
  },
  xxxMemberId: {
    value: '',
    type: 'string',
    required: false,
  },
  xxxPassword: {
    value: '',
    type: 'protected-secret',
    required: false,
  },
  ensId: {
    value: '',
    type: 'string',
    required: false,
  },
  ensPassword: {
    value: '',
    type: 'protected-secret',
    required: false,
  },
  profession: {
    value: '',
    type: 'string',
    required: false,
  },
  travelUinId: {
    value: '',
    type: 'string',
    required: false,
  },
}
